import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64e733e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "wrap",
  class: "live-template-preview",
  "element-loading-text": "Loading preview..."
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      ref: "frame",
      class: "live-template-preview__frame",
      src: _ctx.frameSrc,
      style: _normalizeStyle(_ctx.frameStyle),
      frameborder: "0",
      scrolling: "no",
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFrameLoad && _ctx.onFrameLoad(...args)))
    }, null, 44, _hoisted_2)
  ])), [
    [_directive_loading, !_ctx.ready]
  ])
}